/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmContractSourceCodeInfo } from './EvmContractSourceCodeInfo';

export type HumanityContractCodeInfo = {
    CNM: string;
    STS: HumanityContractCodeInfo.STS;
    OPT: HumanityContractCodeInfo.OPT;
    RUN: string;
    CV: string;
    EV: string;
    SCLIST: Array<EvmContractSourceCodeInfo>;
    ABI: string;
    CCC: string;
    DBC: string;
};

export namespace HumanityContractCodeInfo {

    export enum STS {
        VERIFIED = 'VERIFIED',
    }

    export enum OPT {
        Y = 'Y',
        N = 'N',
    }


}

